<div class="justup-dialog-medium justup-dialog-zoned flex-col">

  <!-- ═════════ Header sticky ═════════ -->
  <div class="dialog-sticky-top">
    <vl-header-dialog (close)="onCancel()">
      {{ data.title }}
      @if (data.subtitle) {
        <span class="caption on-background-alt ml-12">· {{ data.subtitle }}</span>
      }
    </vl-header-dialog>
  </div>

  <!-- ═════════ Body ═════════ -->
  <div class="dialog-body flex-col gap-16">

    <p class="caption on-background-alt">
      Vérifie ou ajuste les paramètres avant de générer le fichier Excel.
      Le fichier reflètera la période et les options sélectionnées ci-dessous.
    </p>

    <!-- ─── Période ─── -->
    @if (data.periodOptions?.length && !customRange()) {
      <div class="flex-col gap-6">
        <span class="caption on-background-alt">Période</span>
        <vl-chips-toggle
          [elements]="data.periodOptions"
          [value]="selectedPeriod()"
          (valueChange)="selectedPeriod.set($event)"
          size="small"/>
      </div>
    }

    <!-- ─── Plage personnalisée (toggle + datepickers) ─── -->
    @if (data.allowCustomRange) {
      <div class="flex-col gap-8">
        <mat-slide-toggle
          [checked]="customRange()"
          (change)="customRange.set($event.checked)"
          color="primary">
          <span class="caption">Plage de dates personnalisée</span>
        </mat-slide-toggle>

        @if (customRange()) {
          <div class="custom-range-grid">
            <div class="flex-col gap-4">
              <span class="tiny on-background-alt">Date de début</span>
              <vl-datetime-picker
                mode="date"
                [dateOnly]="true"
                [value]="customStart()"
                (valueChange)="customStart.set($event)"/>
            </div>
            <div class="flex-col gap-4">
              <span class="tiny on-background-alt">Date de fin</span>
              <vl-datetime-picker
                mode="date"
                [dateOnly]="true"
                [value]="customEnd()"
                (valueChange)="customEnd.set($event)"/>
            </div>
          </div>
          @if (!canConfirm()) {
            <span class="caption warn-text">
              Renseigne les deux dates pour continuer.
            </span>
          }
        }
      </div>
    }

    <!-- ─── Toggles génériques ─── -->
    @if (data.toggles?.length) {
      <div class="flex-col gap-8">
        <span class="caption on-background-alt">Options</span>
        @for (t of data.toggles; track t.id) {
          <div class="flex-col gap-2">
            <mat-slide-toggle
              [checked]="toggleStates()[t.id]"
              (change)="toggleValue(t.id, $event.checked)"
              color="primary">
              <span class="caption">{{ t.label }}</span>
            </mat-slide-toggle>
            @if (t.hint) {
              <span class="tiny on-background-alt ml-32">{{ t.hint }}</span>
            }
          </div>
        }
      </div>
    }
  </div>

  <!-- ═════════ Footer sticky ═════════ -->
  <div class="dialog-sticky-bottom flex-row gap-8 justify-end">
    <vl-big-button
      color="basic"
      type="fit"
      text="Annuler"
      (action)="onCancel()"/>
    <vl-big-button
      color="accent"
      type="fit"
      icon="table_view"
      [text]="data.confirmLabel ?? 'Générer le fichier Excel'"
      [disabled]="!canConfirm()"
      (action)="onConfirm()"/>
  </div>
</div>
